import { MAX_UPLOAD_FILES_PER_SESSION } from '@/utils/uploadSessionLimits';
import { NAV_HUB_CARD_IMAGES } from './navHubCardImages';

export const IMAGE_FISSION_MAX_SOURCES = MAX_UPLOAD_FILES_PER_SESSION;
export const IMAGE_FISSION_VARIATION_COUNT_OPTIONS = [1, 2, 3, 4];

export const DEFAULT_FISSION_PATTERN_ONLY = false;

export { DEFAULT_FISSION_ASPECT_SIZE as DEFAULT_FISSION_ASPECT_PARAMS } from './imageFissionAspectSize';

export function getImageFissionStudioConfig(navId = 'imageFission') {
  const isPattern = navId === 'patternFission';
  const images = isPattern ? NAV_HUB_CARD_IMAGES.patternFission : NAV_HUB_CARD_IMAGES.imageFission;
  return {
    title: isPattern ? 'AI图案裂变' : 'AI图片裂变',
    subtitle: isPattern
      ? '上传印花图案，一键生成多款风格与配色变体'
      : '上传白板商品原图，一键生成同品多场景图',
    hero: {
      image: images.result,
      caption: isPattern ? '单张图案，多款印花变体' : '同品多场景，一键裂变',
    },
    tryExamples: [
      {
        id: 'demo-1',
        thumb: images.source,
        sampleUrl: images.source,
      },
      {
        id: 'demo-2',
        thumb: images.result,
        sampleUrl: images.source,
      },
    ],
  };
}
